import { getOpenPanel } from './getOpenPanel.ts';
import { EASY_COOKIE_ACCEPTED_EVENT } from './constants.ts';

const onBannerSaved = () => {
    getOpenPanel();
};

/**
 * Starts OpenPanel page-view tracking for the current page: asks for the SDK now (outside Germany and France this
 * sends the first page view) and again whenever the EasyCookie banner is saved (inside, this starts it after consent).
 * Idempotent: `addEventListener` ignores a listener it already has. Every surface calls this one function.
 */
export const startOpenPanel = () => {
    if (typeof window === 'undefined') {
        return;
    }
    getOpenPanel();
    window.addEventListener(EASY_COOKIE_ACCEPTED_EVENT, onBannerSaved);
};
